<div class="card pl-3 pr-3 pb-3 pt-2 mb-2">
  <ng-container *ngFor="let ability of abilities; let i = index">
    <div [ngClass]="i !== selectedAbilityIndex ? 'border-bottom' : ''"
         class="d-flex justify-content-between clickable pt-2 align-text-bottom">
      <div (click)="showAbility(i)" class="d-flex justify-content-between w-100 align-items-start">
        <p class="font-weight-bold text-wrap my-2">{{ability.name}}</p>
      </div>

      <fa-icon (click)="showAbility(i)" [icon]="selectedAbilityIndex !== i ? faAngleDown : faAngleUp"
               class="fa mr-1" style="font-size: 1.25em"></fa-icon>
    </div>
    <div *ngIf="i === selectedAbilityIndex" class="d-flex flex-column bg-light pt-2 pr-3 pl-3 border pb-2 slide"
         style="font-size: 0.8em" id="abilityForm" @slideUpDown>
      <div *ngIf="selectedAbilityIndex === i">
        <p>
          <span *ngIf="ability.castingTime"><strong>Casting Time: </strong>{{ability.castingTime}}<br></span>
          <span *ngIf="ability.range"><strong>Range: </strong>{{ability.range}}<br></span>
          <span *ngIf="ability.duration"><strong *ngIf="ability.duration">Duration: </strong>{{ability.duration}}<br></span>
          {{ability.description}}
        </p>
      </div>
      <div class="w-100">
        <fa-icon (click)="editAbility(i)" [icon]="faPencil" class="fa mr-2 float-right clickable"
                 style="font-size: 1.25em"></fa-icon>
      </div>
    </div>
  </ng-container>
</div>
